import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationItem } from 'src/app/core/models/notification-item';

import { RbacService, SystemViewModel } from '@src/app/api-info/system-management-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig, UserProfileService } from 'sigv-library';
import { deepCopy, isNullOrEmpty } from '../utils/common-functions';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  updateReadCount$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected appConfig: AppConfig,
    private http: HttpClient,
    private userProfileService: UserProfileService,
    private rbacService: RbacService
  ) {}

  getUnReadCount(): Observable<number> {
    const useRole = this.userProfileService.currentUserValue
      ?.extranetUserRole as any;
    const url = `${this.appConfig.getApiUrl('webSubmission')}/News/Count`;
    const headers = new HttpHeaders().append('X-UseRole', useRole?.toString());

    return this.http
      .get<any>(url, { headers })
      .pipe(map((x) => x.unreadCount ?? 0));
  }

  getNotifications(count?: number): Observable<NotificationItem[]> {
    const userNo = this.userProfileService.currentUserValue
      ?.userNo as any;
    const useRole = this.userProfileService.currentUserValue
      ?.extranetUserRole as any;
    const url = `${this.appConfig.getApiUrl('webSubmission')}/News/PushMessage/Search`;
    let params = new HttpParams();
    if (!isNullOrEmpty(count)) {
      params = params.append('Number', count!.toString());
    }
    params = params.append('Domain', 'ExWebSubmission');
    const headers = new HttpHeaders()
      .append('X-UserNo', userNo?.toString())
      .append('X-UseRole', useRole?.toString());

    return this.http
      .get<any>(url, { headers, params })
      .pipe(map((x) => deepCopy(x)));
  }

  deleteNotifications(ids: number[]): Observable<void> {
    const url = `${this.appConfig.getApiUrl('webSubmission')}/News/Delete`;
    return this.http.post<any>(url, { id: ids });
  }

  updateToRead(ids: number[]): Observable<void> {
    const url = `${this.appConfig.getApiUrl(
      'webSubmission'
    )}/News/Notification`;
    return this.http.post<any>(url, { id: ids });
  }

  getSystemUrl(systemId: number): Observable<SystemViewModel> {
    return this.rbacService.rbacSystemSystemIdGet(systemId).pipe(
      map((res) => res || {} as SystemViewModel) // 確保回傳型別正確，避免 null 或 undefined
    );
  }

  async getWebsubmissionSystem(): Promise<SystemViewModel> {
    var system = await this.rbacService.rbacSystemGet().toPromise();

    var result = system.find(x => x.systemCode == 'ExWebSubmission');
    return result!;
  }
}
